/* ==========================================================================
   dtc-turntable.js — section 01 "Our Bestsellers", the drag-to-spin rack.

   PHYSICS (exact, from the design prototype's Component class)
   -----------------------------------------------------------
     step    = 360 / itemCount           (72° with the design's 5 shirts)
     angle   = rot + i * step
     R       = min(stageWidth * 0.36, 430)
     x       = sin(angle) * R
     scale   = .46 + .54 * (cos(angle) + 1) / 2
     opacity = .22 + .78 * (cos(angle) + 1) / 2
     zIndex  = 100 + round(cos(angle) * 100)
     front   = the index with the largest cos

     auto-spin : rot -= 0.05 per frame
     drag      : rot += dx * 0.28
     release   : snapT = round(rot / step) * step, then rot += (snapT-rot)*0.1
                 each frame until |delta| < 0.1

   PAUSES when: dragging, the pointer is over the stage, the stage is off
   screen (IntersectionObserver + a rect check), or auto-spin is switched off.

   NOT ENHANCED AT ALL under prefers-reduced-motion — the server-rendered
   scroll-snap row stays exactly as it is, fully shoppable.

   No libraries. Every rAF, listener and observer is released on cleanup so
   the theme editor can mount and unmount this section freely.
   ========================================================================== */
(function () {
  'use strict';

  var DTC = window.DTC;
  if (!DTC || !DTC.register) return;

  DTC.register('turntable', {
    init: function (root) {
      var tt = root.querySelector('[data-tt]');
      if (!tt) return;

      var stage = tt.querySelector('[data-tt-stage]');
      var items = Array.prototype.slice.call(tt.querySelectorAll('[data-tt-item]'));
      if (!stage || items.length < 2) return;

      /* Reduced motion → keep the static, fully shoppable scroll-snap row. */
      if (DTC.reducedMotion) return;

      var frontLink = tt.querySelector('[data-tt-front-link]');
      var frontPrice = tt.querySelector('[data-tt-front-price]');
      var addBtn = tt.querySelector('[data-tt-add]');
      var chooseLink = tt.querySelector('[data-tt-choose]');
      var dots = Array.prototype.slice.call(tt.querySelectorAll('[data-tt-dot]'));

      var T_ADD = tt.getAttribute('data-t-quickadd') || 'Quick add';
      var T_CHOOSE = tt.getAttribute('data-t-choose') || 'Choose options';
      var T_SOLD = tt.getAttribute('data-t-soldout') || 'Sold out';

      var autoSpin = tt.getAttribute('data-auto-spin') !== 'false';
      var step = 360 / items.length;

      var rot = 0;
      var snapT = null;
      var dragging = false;
      var hovering = false;
      var visible = true;
      var moved = 0;
      var dx = 0;
      var curFront = -1;
      var raf = 0;

      tt.classList.add('is-live');

      /* -------------------------------------------------------------- *
       * Front-of-stage panel (name / price / quick add / dots)
       * -------------------------------------------------------------- */
      function setFront(i) {
        curFront = i;
        var el = items[i];
        if (!el) return;

        var name = el.getAttribute('data-name') || '';
        var url = el.getAttribute('data-url') || '#';
        var available = el.getAttribute('data-available') === 'true';
        var multi = el.getAttribute('data-multi') === 'true';
        var variantId = el.getAttribute('data-variant-id') || '';

        if (frontLink) {
          frontLink.textContent = name;
          frontLink.setAttribute('href', url);
        }
        if (frontPrice) frontPrice.textContent = el.getAttribute('data-price') || '';

        if (addBtn && chooseLink) {
          if (!available) {
            chooseLink.hidden = true;
            addBtn.hidden = false;
            addBtn.disabled = true;
            addBtn.removeAttribute('data-dtc-quickadd');
            addBtn.removeAttribute('data-variant-id');
            addBtn.textContent = T_SOLD;
          } else if (multi || !variantId) {
            /* Never blind-add a multi-variant product — send them to the PDP. */
            addBtn.hidden = true;
            chooseLink.hidden = false;
            chooseLink.setAttribute('href', url);
            chooseLink.textContent = T_CHOOSE;
          } else {
            chooseLink.hidden = true;
            addBtn.hidden = false;
            addBtn.disabled = false;
            addBtn.setAttribute('data-dtc-quickadd', '');
            addBtn.setAttribute('data-variant-id', variantId);
            addBtn.setAttribute('data-product-title', name);
            addBtn.textContent = T_ADD;
          }
        }

        for (var d = 0; d < dots.length; d++) {
          if (d === i) dots[d].setAttribute('aria-current', 'true');
          else dots[d].removeAttribute('aria-current');
        }
      }

      /* -------------------------------------------------------------- *
       * rAF loop
       * -------------------------------------------------------------- */
      function tick() {
        raf = requestAnimationFrame(tick);
        if (!visible) return;

        var r = stage.getBoundingClientRect();
        if (r.bottom < -100 || r.top > window.innerHeight + 100) return;

        if (!dragging) {
          if (snapT !== null) {
            var d = snapT - rot;
            if (Math.abs(d) < 0.1) { rot = snapT; snapT = null; }
            else rot += d * 0.1;
          } else if (!hovering && autoSpin && !DTC.reducedMotion) {
            rot -= 0.05;
          }
        }

        var R = Math.min(r.width * 0.36, 430);
        var next = 0;
        var bc = -2;

        for (var i = 0; i < items.length; i++) {
          var a = (rot + i * step) * Math.PI / 180;
          var c = Math.cos(a);
          var s = Math.sin(a);
          var el = items[i];
          el.style.transform =
            'translate(-50%,-50%) translateX(' + (s * R).toFixed(1) + 'px) scale(' +
            (0.46 + 0.54 * (c + 1) / 2).toFixed(3) + ')';
          el.style.opacity = (0.22 + 0.78 * (c + 1) / 2).toFixed(3);
          el.style.zIndex = String(100 + Math.round(c * 100));
          if (c > bc) { bc = c; next = i; }
        }

        if (next !== curFront) setFront(next);
      }

      /* -------------------------------------------------------------- *
       * Snapping
       * -------------------------------------------------------------- */
      function norm(x) { return ((x % 360) + 360) % 360; }

      function goFront(i) {
        var d = norm(-i * step - rot);
        if (d > 180) d -= 360;
        snapT = rot + d;
      }

      function snapNearest() { snapT = Math.round(rot / step) * step; }

      /* -------------------------------------------------------------- *
       * Pointer drag (mouse, pen and touch — touch-action: pan-y keeps
       * vertical page scrolling free)
       * -------------------------------------------------------------- */
      function onDown(e) {
        dragging = true;
        snapT = null;
        moved = 0;
        dx = e.clientX;
        stage.classList.add('is-dragging');
        try { stage.setPointerCapture(e.pointerId); } catch (err) { /* no capture available */ }
      }

      function onMove(e) {
        if (!dragging) return;
        var delta = e.clientX - dx;
        moved += Math.abs(delta);
        rot += delta * 0.28;
        dx = e.clientX;
      }

      function endDrag() {
        if (!dragging) return;
        dragging = false;
        stage.classList.remove('is-dragging');
        snapNearest();
      }

      function onEnter() { hovering = true; }
      function onLeave() { hovering = false; endDrag(); }

      /* A drag that happens to end on top of a shirt must not navigate.
         Keyboard activation (Enter on a link, Space on the quick-add) arrives
         as a click with detail 0 and no pointerType, and crucially with NO
         pointerdown before it to reset `moved` — so it must never be
         suppressed, or a stale drag would silently eat the first keypress
         and the shopper would have to press Enter twice. */
      function onClickCapture(e) {
        if (!e.detail && (!('pointerType' in e) || !e.pointerType)) return;
        if (moved > 8) {
          e.preventDefault();
          e.stopPropagation();
        }
        moved = 0;
      }

      /* Keyboard: focusing a shirt spins it to the front. */
      function onFocusIn(e) {
        /* The browser scrolls a focused element into view before we get here.
           The stage is clipped (see .dtc-tt.is-live in the CSS) so there is
           nothing legitimate to scroll — but on an engine without `overflow:
           clip` that native scroll can shunt the whole section sideways with
           no scrollbar to undo it. Put it back. */
        if (tt.scrollLeft) tt.scrollLeft = 0;

        var item = e.target.closest ? e.target.closest('[data-tt-item]') : null;
        if (!item) return;
        var i = items.indexOf(item);
        if (i >= 0) goFront(i);
      }

      function onDotClick(e) {
        var i = parseInt(e.currentTarget.getAttribute('data-index'), 10);
        if (!isNaN(i)) goFront(i);
      }

      var offs = [];
      offs.push(DTC.on(stage, 'pointerdown', onDown));
      offs.push(DTC.on(stage, 'pointermove', onMove));
      offs.push(DTC.on(stage, 'pointerup', endDrag));
      offs.push(DTC.on(stage, 'pointercancel', endDrag));
      offs.push(DTC.on(stage, 'pointerenter', onEnter));
      offs.push(DTC.on(stage, 'pointerleave', onLeave));
      offs.push(DTC.on(stage, 'click', onClickCapture, true));
      offs.push(DTC.on(stage, 'focusin', onFocusIn));
      offs.push(DTC.on(stage, 'dragstart', function (e) { e.preventDefault(); }));
      dots.forEach(function (dot) { offs.push(DTC.on(dot, 'click', onDotClick)); });

      /* -------------------------------------------------------------- *
       * Pause the loop while the rack is off screen.
       * -------------------------------------------------------------- */
      var io = null;
      if ('IntersectionObserver' in window) {
        io = new IntersectionObserver(function (entries) {
          visible = entries[entries.length - 1].isIntersecting;
        }, { rootMargin: '120px 0px' });
        io.observe(stage);
      }

      setFront(0);
      raf = requestAnimationFrame(tick);

      /* -------------------------------------------------------------- *
       * Cleanup — the theme editor mounts and unmounts constantly.
       * -------------------------------------------------------------- */
      return function cleanup() {
        cancelAnimationFrame(raf);
        if (io) io.disconnect();
        offs.forEach(function (off) { off(); });
        offs.length = 0;
        tt.classList.remove('is-live');
        stage.classList.remove('is-dragging');
        items.forEach(function (el) {
          el.style.transform = '';
          el.style.opacity = '';
          el.style.zIndex = '';
        });
      };
    }
  });
}());
